const { sameRunStyleInTextBodies } = require('../utils');

exports.computeFontColorFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(textBodies, 'color', undefined, { textSelection });
